import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  LangSelectItem, langSelectList,
  MenuItem,
  SecondaryMenuItem,
  SidebarMenuItems,
} from '@shared/components/most-used/sidebar/sidebar.config';
import { AppModes, AppService } from '@shared/services/app.service';
import { CurrentUserService } from '@shared/services/current-user.service';
import { Langs, LangService } from '@shared/services/lang.service';
import { RoutesService } from '@shared/services/routes.service';
import { SidebarService } from '@shared/services/sidebar.service';
import { GetAppMode } from '@shared/utils/roles.utils';
import { BehaviorSubject } from 'rxjs';
import { lastBuildTimestamp } from '../../../../../build-timestamp';
import { environment } from '../../../../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: [ './sidebar.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent implements OnInit {
  links$ = new BehaviorSubject<MenuItem[]>([]);
  secondaryLinks: SecondaryMenuItem[] = [ { title: $localize`Данные` }, { title: $localize`Настройки` } ];
  langLinks: LangSelectItem[] = langSelectList;
  currentLang: Langs = this.langService.lang;
  appModes = AppModes;
  appMode: AppModes;
  isProd = environment.production;
  showDevSection = false;
  maxCounterValue = environment.production ? 99 : 999;
  showVersionModal = false;
  version: { buildMessage: string; pushMessage?: string };

  constructor(
    private langService: LangService,
    public appService: AppService,
    public currentUserService: CurrentUserService,
    public sidebarService: SidebarService,
    private routesService: RoutesService,
    private cd: ChangeDetectorRef
  ) {
    GetAppMode(this);
    this.appService.appMode$.pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        this.links$.next(SidebarMenuItems.filter((item) => {
          return item.visibility.includes(data);
        }));
        this.cd.markForCheck();
      },
    });
  }

  ngOnInit(): void {
    const savedShowDevSection = localStorage.getItem('melitta-showDevSection');
    if (savedShowDevSection) {
      this.showDevSection = JSON.parse(savedShowDevSection);
    }
  }

  // setLang(lang: string) {
  setLang(event: MatSelectChange) {
    const lang = event.value;
    this.langService.setLang(lang as Langs);
  }

  changeModForDev(mode: AppModes) {
    this.currentUserService.setModeForDev(mode);
    setTimeout(() => {
      window.location.reload();
    }, 10);
  }

  toggleShowDevSection() {
    if (environment.production) {
      return;
    }
    this.showDevSection = !this.showDevSection;
    localStorage.setItem('melitta-showDevSection', JSON.stringify(this.showDevSection));
  }

  debug() {
    console.log(this.routesService.currentUrl);
  }

  showVersion() {
    const buildMessage = 'Last build time: '
      + (lastBuildTimestamp ? (new Date(lastBuildTimestamp)).toLocaleString() : 'unknown');
    // const pushMessage = 'Last push time: ' +
    //   (lastPushTimestamp ? (new Date(lastPushTimestamp)).toLocaleString() : 'unknown');
    console.log(buildMessage, lastBuildTimestamp);
    this.version = { buildMessage };
    this.showVersionModal = true;
  }
}
